import { useEffect, useState } from "react";
import { X, Phone } from "lucide-react";
import { toast } from "sonner";
import { api, USER_ID } from "../api";

export const openPhoneGate = () => window.dispatchEvent(new CustomEvent("xp-phone-gate"));

export const PhoneGate = ({ onLinked }) => {
  const [open, setOpen] = useState(false);
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("xp-phone-gate", h);
    return () => window.removeEventListener("xp-phone-gate", h);
  }, []);

  if (!open) return null;

  const save = async () => {
    setBusy(true);
    try {
      await api.post("/passport/link-phone", { user_id: USER_ID, phone });
      toast.success("Phone linked — the whole mela is yours! ਬੱਲੇ ਬੱਲੇ!", { style: { background: "#1A1A1A", color: "#D4AF37" } });
      setOpen(false);
      onLinked?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not link that number"); }
    setBusy(false);
  };

  return (
    <div data-testid="phone-gate-modal" className="fixed inset-0 z-[1200] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/75 backdrop-blur-sm" onClick={() => setOpen(false)} />
      <div className="relative w-full max-w-sm rounded-2xl border border-[#F0C742]/50 bg-[#14100A] p-6 text-center">
        <button data-testid="phone-gate-close" aria-label="Close" onClick={() => setOpen(false)}
          className="absolute top-3 right-3 w-8 h-8 rounded-full border border-white/15 text-white/60 flex items-center justify-center"><X size={13} /></button>
        <img src="/mela/coin.png" alt="Regal Coins" className="w-14 h-14 object-contain mx-auto" />
        <p className="font-display text-xl font-bold mt-3">Keep your coins forever</p>
        <p className="text-xs text-white/55 mt-2">You're playing in trial mode. Add your phone number to play unlimited games and save your Regal Coins, badges and leaderboard spot to your passport.</p>
        <div className="flex items-center gap-2 mt-4 rounded-full border border-[#D4AF37]/40 bg-[#121212] px-4">
          <Phone size={14} className="text-[#D4AF37] shrink-0" />
          <input data-testid="phone-gate-input" value={phone} onChange={(e) => setPhone(e.target.value)}
            type="tel" inputMode="tel" placeholder="(312) 555-0123" autoFocus
            onKeyDown={(e) => e.key === "Enter" && save()}
            className="flex-1 min-w-0 bg-transparent h-11 text-sm focus:outline-none" />
        </div>
        <button data-testid="phone-gate-save" onClick={save} disabled={busy || phone.replace(/\D/g, "").length < 8}
          className="mt-3 w-full h-11 rounded-full bg-[#F0C742] text-black text-xs font-black tracking-widest disabled:opacity-50">
          {busy ? "LINKING…" : "SAVE & PLAY UNLIMITED"}
        </button>
        <button data-testid="phone-gate-later" onClick={() => setOpen(false)}
          className="mt-2 text-[10px] text-white/40 font-bold tracking-widest">MAYBE LATER</button>
      </div>
    </div>
  );
};
